import { Box, Theme } from "@mui/material";
import { formatNum } from "src/lib/number.helpers";

import { TooltipExpectedVisitors } from "./TooltipExpectedVisitors";
import { getStyles } from "./utils/styles";
import { determineArrow, determineColor } from "../Dashboard/helpers/dashboardChart.helper";
import { ChartTooltipFormatterParams } from "../Dashboard/interfaces/DashboardComponentParams";
import { IntervalTab } from "../IntervalTabs/enum/IntervalTab";

export function TooltipDiffRow({
  param,
  firstValue,
  secondValue,
  theme,
  expectedVisitors,
  intervalTab,
  showColorSpan,
  hasWeather = false,
}: {
  param: ChartTooltipFormatterParams;
  firstValue?: number;
  secondValue?: number;
  theme: Theme;
  expectedVisitors: number | null;
  intervalTab: IntervalTab;
  showColorSpan: boolean;
  hasWeather: boolean;
}) {
  const styles = getStyles(theme);

  const diff = !firstValue || !secondValue || firstValue === 0 || secondValue === 0 ? 0 : ((firstValue - secondValue) / secondValue) * 100;

  const color = determineColor(diff, theme);
  const arrow = determineArrow(diff);

  const textAlign = hasWeather ? "left" : "right";
  const colAlignStyle = textAlign === "left" ? styles.popupColLeft : styles.popupColRight;

  return (
    <>
      <Box style={styles.popupRow4Cols}>
        <Box style={styles.popupCol}>
          <Box style={styles.row}>
            {showColorSpan && <Box style={getStyles(theme, param.color).boxSquere} />}
            <Box style={styles.textPrimary}>{param.seriesName}</Box>
          </Box>
        </Box>

        <Box style={styles.popupColRight}>
          <Box style={styles.textPrimaryBold}>{formatNum(firstValue ?? 0)}</Box>
        </Box>

        <Box style={colAlignStyle}>
          <Box style={styles.textSecondary}>{formatNum(secondValue ?? 0)}</Box>
        </Box>

        <Box style={styles.popupColRight}>
          <Box style={getStyles(theme, color).diff}>
            {arrow} {diff === 0 ? "" : `${Math.abs(diff).toFixed(1)}%`}
          </Box>
        </Box>
      </Box>

      {expectedVisitors !== null && <TooltipExpectedVisitors expectedVisitors={expectedVisitors} intervalTab={intervalTab} theme={theme} />}
    </>
  );
}
